import { EmptyState } from "@c/shared";
import { useNotifications } from "@h/useNotifications";
import { cn } from "@u/cn";
import { Bell, CheckCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NotificationRow } from "./NotificationRow";

export function NotificationPanel({
  onClose,
  inSheet = false,
}: {
  onClose?: () => void;
  inSheet?: boolean;
}) {
  const { t } = useTranslation();
  const { notifications, markRead, markAllRead, unreadCount } = useNotifications();

  return (
    <div
      className={cn(
        "flex flex-col",
        // popover: fixed card. sheet: full-bleed (cancel drawer px-4), let sheet scroll.
        inSheet ? "-mx-5" : "w-80 max-w-[90vw] max-h-[70dvh]",
      )}
    >
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <span className="text-sm text-foreground">
          {t("notif.title_panel", "Notificaciones")}
        </span>
        {unreadCount > 0 && (
          <button
            type="button"
            onClick={() => markAllRead()}
            className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
          >
            <CheckCheck size={13} />
            {t("notif.mark_all_read", "Marcar todas")}
          </button>
        )}
      </div>
      <div className={cn("divide-y divide-border/60", !inSheet && "overflow-y-auto")}>
        {notifications.length === 0 ? (
          <div className="p-6">
            <EmptyState
              icon={Bell}
              title={t("notif.empty_title", "Sin notificaciones")}
              description={t("notif.empty_desc", "Te avisaremos cuando pase algo.")}
            />
          </div>
        ) : (
          notifications.map((n) => (
            <NotificationRow key={n.id} n={n} onRead={markRead} onNavigate={onClose} />
          ))
        )}
      </div>
    </div>
  );
}
